import { FormControl } from "@angular/forms";
import { NaturvardesbedomningKalla } from "~app/features/virkeskop/models/naturvardesbedomning-models";

export interface NvbLeveransvirkeFormGroup {
    misstankeOmHogaNaturvarden: FormControl<boolean>;
    atgardsTyp: FormControl<string>;
    formOrFileNvb: FormControl<NaturvardesbedomningKalla>;
    formOrFileRiskbedomning: FormControl<NaturvardesbedomningKalla>;
}

export enum NvbLeveransvirkeFormStep {
    MisstankeOmHogaNaturvarden = 1,
    AtgardsTyp = 2,
    FormOrFileNvb = 3,
    FormOrFileRiskbedomning = 4,
    NvbFormular = 5,
    NvbFil = 6,
    ForenkladRiskbedomning = 8,
    ForenkladRiskbedomningFil = 9
}

export enum NvbLeveransvirkeAtgardsTyp {
    Favv = "Föryngringsavverkning",
    Övrig = "Övrig avverkning"
}
